import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../../../shared-ui/src/lib/loader/loader.service';

@Component({
  selector: 'kodit-subscription-expired-layout',
  templateUrl: './inactive-or-expired-layout.component.html',
  styleUrls: ['./inactive-or-expired-layout.component.scss'],
})
export class InactiveOrExpiredLayout implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  showLoadingPage: boolean = false;

  constructor(private _loader: LoaderService) {}

  ngOnInit(): void {
    this._subs.add(
      this._loader.getShowLoader.subscribe((showLoader) => {
        this.showLoadingPage = showLoader;
      })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
